var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77794 19.5503C8.32803 20.1407 9.03422 20.4651 9.76696 20.4651H9.76803C10.504 20.4651 11.2133 20.1407 11.7645 19.5493C12.0597 19.2352 12.5631 19.2096 12.8891 19.493C13.2162 19.7765 13.2427 20.2625 12.9486 20.5767C12.0905 21.4945 10.9617 22 9.76803 22H9.7659C8.57546 21.999 7.44873 21.4935 6.59387 20.5756C6.29971 20.2615 6.32626 19.7754 6.65334 19.493C6.98042 19.2086 7.48378 19.2341 7.77794 19.5503ZM9.81985 0C14.5402 0 17.7112 3.54251 17.7112 6.8507C17.7112 8.55237 18.1604 9.27377 18.6372 10.0392C19.1087 10.7943 19.6429 11.6518 19.6429 13.2727C19.2722 17.4138 14.7855 17.7514 9.81985 17.7514C4.85419 17.7514 0.3664 17.4138 1.40563e-05 13.3381C-0.0031576 11.6518 0.531002 10.7943 1.00251 10.0392L1.16896 9.76918C1.5788 9.09046 1.92852 8.35218 1.92852 6.8507C1.92852 3.54251 5.0995 0 9.81985 0ZM9.81985 1.53488C6.10835 1.53488 3.52144 4.33656 3.52144 6.8507C3.52144 8.97805 2.9087 9.9614 2.36711 10.8291C1.93277 11.526 1.58976 12.0765 1.58976 13.2727C1.76711 15.2025 3.08923 16.2166 9.81985 16.2166C16.5133 16.2166 17.8768 15.1575 18.0531 13.2061C18.0499 12.0765 17.7069 11.526 17.2726 10.8291C16.731 9.9614 16.1183 8.97805 16.1183 6.8507C16.1183 4.33656 13.5314 1.53488 9.81985 1.53488Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.af63bbad517ce1419484717006c1fe36.svg";
export { ForwardRef as ReactComponent };